import { orgLevelMenuItems } from './constants/constants';

/**
 * Returns the org levels a creator is allowed to create/edit.
 * This is the single source of truth for org creation rules.
 */
export const getAllowedOrgLevels = (creatorLevel) => {
  switch (creatorLevel) {
    case 'PLATFORM':
      return orgLevelMenuItems.filter(
        (item) =>
          item.value === 'PLATFORM' ||
          item.value === 'CHANNEL_PARTNER' ||
          item.value === 'CHANNEL_PARTNER_DIRECT'
      );
    case 'CHANNEL_PARTNER_DIRECT':
      return orgLevelMenuItems.filter(
        (item) => item.value === 'CORE' || item.value === 'ENTERPRISE'
      );
    case 'CHANNEL_PARTNER':
      return orgLevelMenuItems.filter(
        (item) => item.value === 'STANDARD' || item.value === 'PROSPECTING'
      );
    default:
      return orgLevelMenuItems.filter(
        (item) => item.value === 'STANDARD' || item.value === 'PROSPECTING'
      );
  }
};

/**
 * Given a set of allowed levels and the currently selected org's level,
 * returns the dropdown options. If the current org's level is outside
 * the allowed list (e.g. editing an existing org), it's included so
 * the Select can display it.
 */
export const getOrgLevelSelection = (allowedLevels, currentLevel) => {
  if (currentLevel && !allowedLevels.find((item) => item.value === currentLevel)) {
    const currentItem = orgLevelMenuItems.find((item) => item.value === currentLevel);
    if (currentItem) return [currentItem, ...allowedLevels];
  }
  return allowedLevels;
};

/**
 * Returns a sensible default level when creating a new org.
 */
export const getDefaultChildLevel = (creatorLevel) => {
  switch (creatorLevel) {
    case 'PLATFORM':
      return 'CHANNEL_PARTNER';
    case 'CHANNEL_PARTNER_DIRECT':
      return 'CORE';
    default:
      return 'STANDARD';
  }
};

/**
 * Restricts pricing model choices based on the parent (current) org's model.
 * Only CHANNEL_PARTNER restricts children.
 */
export const getRestrictedPriceModels = (parentLevel, parentModel, allModels) => {
  if (parentLevel !== 'CHANNEL_PARTNER' || parentModel === 'Hybrid') {
    return allModels;
  }
  return allModels.filter((opt) => opt.value === parentModel);
};
